import NoRecordsFound from './NoRecordsFound';
export default NoRecordsFound;
